export * from './activity.service';
export * from './address.service';
export * from './agenda.service';
export * from './age-range.service';
export * from './alert-message.service';
export * from './alert.service';
export * from './analytics.service';
export * from './auth.service';
export * from './benefit.service';
export * from './blog.service';
export * from './body-class.service';
export * from './breakpoints.service';
export * from './bt-company-page.service';
export * from './corporate.service';
export * from './faqbot.service';
export * from './faq-page.service';
export * from './franchise.service';
export * from './gym-search-cache.service';
export * from './gym-search-real.service';
export * from './gym.service';
export * from './header.service';
export * from './loading.service';
export * from './modal.service';
export * from './my-contract.service';
export * from './my-purchases.service';
export * from './partners.service';
export * from './plan.service';
export * from './policy.service';
export * from './portal-config.service';
export * from './press-release-page.service';
export * from './price.service';
export * from './registration.service';
export * from './seo.service';
export * from './user.service';
export * from './user-profile.service';
export * from './user-training.service';
export * from './window-context.service';

import { ActivityService } from './activity.service';
import { AddressService } from './address.service';
import { AgendaService } from './agenda.service';
import { AgeRangeService } from './age-range.service';
import { AlertMessageService } from './alert-message.service';
import { AlertService } from './alert.service';
import { AnalyticsService } from './analytics.service';
import { AuthService } from './auth.service';
import { BenefitService } from './benefit.service';
import { BlogService } from './blog.service';
import { BodyClassService } from './body-class.service';
import { BreakpointsService } from './breakpoints.service';
import { BtCompanyPageService } from './bt-company-page.service';
import { CorporateService } from './corporate.service';
import { FaqBotService } from './faqbot.service';
import { FaqPageService } from './faq-page.service';
import { FranchiseService } from './franchise.service';
import { GymSearchCacheService } from './gym-search-cache.service';
import { GymSearchRealService } from './gym-search-real.service';
import { GymService } from './gym.service';
import { HeaderService } from './header.service';
import { LoadingService } from './loading.service';
import { ModalService } from './modal.service';
import { MyContractService } from './my-contract.service';
import { MyPurchasesService } from './my-purchases.service';
import { PartnersService } from './partners.service';
import { PlanService } from './plan.service';
import { PolicyService } from './policy.service';
import { PortalConfigService } from './portal-config.service';
import { PressReleasePageService } from './press-release-page.service';
import { PriceService } from './price.service';
import { RegistrationService } from './registration.service';
import { SEOService } from './seo.service';
import { UserService } from './user.service';
import { UserProfileService } from './user-profile.service';
import { UserTrainingService } from './user-training.service';
import { WindowContextService } from './window-context.service';
import { BrandService } from './brand.service';

export const services = [
  ActivityService,
  AddressService,
  AgendaService,
  AgeRangeService,
  AlertMessageService,
  AlertService,
  AnalyticsService,
  AuthService,
  BenefitService,
  BlogService,
  BodyClassService,
  BrandService,
  BreakpointsService,
  BtCompanyPageService,
  CorporateService,
  FaqBotService,
  FaqPageService,
  FranchiseService,
  GymSearchCacheService,
  GymSearchRealService,
  GymService,
  HeaderService,
  LoadingService,
  ModalService,
  MyContractService,
  MyPurchasesService,
  PartnersService,
  PolicyService,
  PortalConfigService,
  PressReleasePageService,
  RegistrationService,
  SEOService,
  UserService,
  UserTrainingService,
  UserProfileService,
  WindowContextService,

  ActivityService,
  AddressService,
  BenefitService,
  PlanService,
  PriceService,
];
